export type WizardStepId =
  | 'location'
  | 'services'
  | 'materials'
  | 'staff'
  | 'date'
  | 'time'
  | 'details'
  | 'done';

export type BookingEntryMode = 'location' | 'staff';

export interface WizardStepContext {
  entryMode: BookingEntryMode;
  /** Locations the customer can pick from (staff-first multi-location) */
  locationOptionsCount: number;
  locationFixed: boolean;
  staffFixed: boolean;
  hasBookableMaterials: boolean;
  capableStaffCount: number;
  allowCustomerStaffSelection: boolean;
}

export function buildWizardStepOrder(ctx: WizardStepContext): WizardStepId[] {
  const steps: WizardStepId[] = [];

  if (!ctx.locationFixed && ctx.locationOptionsCount > 1) {
    steps.push('location');
  }

  steps.push('services');

  if (ctx.hasBookableMaterials) {
    steps.push('materials');
  }

  if (
    ctx.allowCustomerStaffSelection &&
    !ctx.staffFixed &&
    ctx.capableStaffCount > 1
  ) {
    steps.push('staff');
  }

  steps.push('date', 'time', 'details', 'done');

  return steps;
}

export function getNextStep(
  current: WizardStepId,
  order: WizardStepId[]
): WizardStepId | null {
  const idx = order.indexOf(current);
  if (idx < 0 || idx >= order.length - 1) return null;
  return order[idx + 1];
}

export function getPrevStep(
  current: WizardStepId,
  order: WizardStepId[]
): WizardStepId | null {
  const idx = order.indexOf(current);
  if (idx <= 0) return null;
  return order[idx - 1];
}

export function stepLabel(step: WizardStepId): string {
  const labels: Record<WizardStepId, string> = {
    location: 'Location',
    services: 'Services',
    materials: 'Materials',
    staff: 'Staff',
    date: 'Date',
    time: 'Time',
    details: 'Details',
    done: 'Done',
  };
  return labels[step];
}
